export interface PaymentCompletedModalProps {}

export default function PaymentCompletedModal({}: PaymentCompletedModalProps) {
  return (
    <>
      <div className="mb-4 text-center">
        {/* Icon */}
        <div className="inline-flex mt-4">
          <svg className="inline-flex w-16 h-16 fill-current mb-6" viewBox="0 0 64 64">
            <circle className="text-green-500/20" cx="32" cy="32" r="32" />
            <path
              className="text-green-700"
              d="M37.22 26.375a1 1 0 1 1 1.56 1.25l-8 10a1 1 0 0 1-1.487.082l-4-4a1 1 0 0 1 1.414-1.414l3.21 3.21 7.302-9.128Z"
            />
          </svg>
        </div>
        <div className="text-lg font-semibold text-gray-800 dark:text-gray-100">Betalning genomförd!</div>
      </div>

      {/* Modal content */}
    </>
  );
}
